import React from 'react'
import * as secretCodeFormType from './secretCodeFormType'

const useSecretCodeForm = (props: secretCodeFormType.UseSecretCodeFormType) => {
    const {} = props
    // const [category, setCategory] = React.useState<closeProjectOfficerFormType.OptType[]>([])

    React.useEffect(() => {}, [])

    return {
        // category,
    }
}

export default useSecretCodeForm
